import { Box, Typography, Divider } from '@mui/material';
import Navbar from '../Layouts/Navbar';

const data = {
  name: 'TEST Wafa QAROUANY',
  entree: {
    heure: '7H',
    adresse: 'F5H5+FHX, Rte de Bounit, Bounit, Maroc',
    dates: ['25/03/2025', '26/03/2025'],
  },
  sortie: {
    heure: 'H',
    dates: [],
  },
};

export default function PreReservationDetail() {
  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box bgcolor="black" color="white" p={1}  fontFamily={'Roboto, sans-serif, Lalezar'}>
          {data.name}
        </Box>

        <Box display="flex" mt={3}>
          {/* ENTREE Section */}
          <Box flex={1} pr={2} borderRight="1px solid #ddd">
            <Box
              bgcolor="red"
              color="white"
              width="fit-content"
              px={2}
              py={0.5}
              mb={2}
              borderRadius="4px"
              fontWeight="bold"
              fontFamily={'Roboto, sans-serif, Lalezar'}
            >
              ENTREE
            </Box>
            <Typography mb={1}>Zone</Typography>
            <Divider />
            <Box display="flex" justifyContent="space-between" py={1}>
              <Typography>Heure d'entrée</Typography>
              <Typography>{data.entree.heure}</Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between" py={1}>
              <Typography>Adresse du domicile</Typography>
              <Typography textAlign="right">{data.entree.adresse}</Typography>
            </Box>
            <Divider />
            <Box py={1}>
              <Typography>Dates nécessitant le transport en entrée</Typography>
              <ul style={{ margin: '0.5rem 0 0 1rem' }}>
                {data.entree.dates.map((date, i) => (
                  <li key={i}>{date}</li>
                ))}
              </ul>
            </Box>
          </Box>

          {/* SORTIE Section */}
          <Box flex={1} pl={2}>
            <Box
              bgcolor="red"
              color="white"
              width="fit-content"
              px={2}
              py={0.5}
              mb={2}
              borderRadius="4px"
              fontWeight="bold"
              fontFamily={'Roboto, sans-serif, Lalezar'}
            >
              SORTIE
            </Box>
            <Typography mb={1}>Zone</Typography>
            <Divider />
            <Box display="flex" justifyContent="space-between" py={1}>
              <Typography>Heure de sortie</Typography>
              <Typography>{data.sortie.heure}</Typography>
            </Box>
            <Divider />
            <Box py={1}>
              <Typography>Dates nécessitant le transport en sortie</Typography>
              {data.sortie.dates.length === 0 ? (
                <Typography mt={0.5} color="text.secondary">
                  -
                </Typography>
              ) : (
                <ul style={{ margin: '0.5rem 0 0 1rem' }}>
                  {data.sortie.dates.map((date, i) => (
                    <li key={i}>{date}</li>
                  ))}
                </ul>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
